import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateSoilTypeDocument,
  CreateSoilTypeInput,
  CreateSoilTypeMutation,
  CreateSoilTypeMutationVariables,
  SoilTypesDocument,
  SoilTypesQuery,
  SoilTypesQueryVariables,
} from "generated/graphql";

@injectable()
export class SoilTypeService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      SoilTypesQuery,
      SoilTypesQueryVariables
    >({
      query: SoilTypesDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.soilTypes;
  }

  async create(input: CreateSoilTypeInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateSoilTypeMutation,
      CreateSoilTypeMutationVariables
    >({
      mutation: CreateSoilTypeDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: SoilTypesDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createSoilType;
  }
}
